<template>
  <s-modal
    v-model="showModal"
    size="lg"
    ok-only
    :ok-title="$t('actions.close')"
    title=""
    @ok="closeModal"
    :html="true"
  >
    <b-container>
      <b-row class="align-items-center title">
        <b-col class="d-flex align-items-center">
          <i class="fas fa-info-circle informationIcon mb-4"></i>
          <h1 class="mb-4 ml-4">{{ modalTitle }}</h1>
        </b-col>
      </b-row>
      <s-table :fields="fields" :items="items">
        <template #cell(icons)="data">
          <b-row align-v="center" align-h="center">
            <span v-if="data.item.icons === 'circle'">
              <i class="fas fa-circle"></i>
            </span>
            <span v-else-if="data.item.icons === 'preview'">
              <div
              class="preview"
              v-html="previewContent()"
              :style="{background: background}"
              />
            </span>
            <span v-else-if="data.item.icons === 'checkbox'">
              <i class="fas fa-check-square checkbox"></i>
            </span>
          </b-row>
        </template>
      </s-table>
    </b-container>
    <b-card class="text-center variables-and-reference">
      <span>{{ $t('reports.oscillography.help-modal.MI004') }}</span>
    </b-card>
  </s-modal>
</template>

<script>
import translate from '@/services/translate';
import themeService from '@/services/themeService';

export default {
  name: 'HelpModal',
  data: () => ({
    showModal: false,
    fields: [
      {
        key: 'icons',
        label: translate('reports.oscillography.help-modal.icons'),
      },
      {
        key: 'description',
        label: translate('reports.oscillography.help-modal.description'),
        class: 'text-start subtitle',
      },
    ],
    items: [
      {
        icons: 'circle',
        description: translate('reports.oscillography.help-modal.MI001'),
      },
      {
        icons: 'preview',
        description: translate('reports.oscillography.help-modal.MI002'),
      },
      {
        icons: 'checkbox',
        description: translate('reports.oscillography.help-modal.MI003'),
      },
    ],
  }),
  methods: {
    show() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    previewContent() {
      const stroke = themeService.isDarkTheme() ? '#FFFFFF' : '#000000';
      const handle = themeService.isDarkTheme() ? '#FFFFFF' : '#4F4F4F';
      return `
        <svg width="100%" height="40" viewBox="0 0 120 40">
          <line x1="10" y1="20" x2="110" y2="20" stroke="${stroke}" stroke-width="4" />
          <circle cx="60" cy="20" r="6" fill="${handle}" />
        </svg>
      `;
    },
  },
  computed: {
    modalTitle() {
      return translate('reports.oscillography.help-modal.title');
    },
    background() {
      return themeService.isDarkTheme() ? 'var(--color-background-dark)' : 'var(--color-neutral-background)';
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"
.variables-and-reference
  background-color: var(--color-custom-light)
  font-size: 1.1em

.informationIcon
  font-size: 1.5em
  margin-left: 10px

.s-table
  border: 1px solid var(--color-table-header-bg) !important
  border-radius: 5px !important
  ::v-deep
    th, td
      text-align: left !important
      border: 3px solid var(--color-background-light) !important
    th:nth-child(1),
    td:nth-child(1)
      min-width: 200px !important
    td:nth-child(2)
      font-size: 1.2em !important
.preview
    background-color: #ffffff
    width: 85px
    height: 50px
    border: 1px solid $color-border-gray
    padding: 5px
    display: flex
    align-items: center
    justify-content: center
    text-align: center
.checkbox
  font-size: 2em
  color: var(--color-primary)
</style>
